<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 4947 4942"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_669817800">
   <path class="fil0" d="M4604 0l-4251 0c-412,0 -343,640 -343,640l4937 0c0,0 29,-640 -343,-640z"/>
   <polygon class="fil0" points="0,1686 4942,1686 4942,1046 0,1046 "/>
   <polygon class="fil0" points="0,2791 4942,2791 4942,2151 0,2151 "/>
   <polygon class="fil0" points="0,3837 4942,3837 4942,3198 0,3198 "/>
   <polygon class="fil0" points="0,4942 4942,4942 4942,4244 0,4244 "/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'JalousieDown',
};
</script>

<style scoped>
.fil0 {fill:#1DAAE1;fill-rule:nonzero}
</style>
